// removed by extract-text-webpack-plugin
module.exports = {"summary":"jz_j0","info":"jz_cb","footer":"jz_t","title":"jz_n","distance":"jz_j1","date":"jz_j2","pricing":"jz_j3 jz_n jz_j2","unavailablePricing":"jz_j4 jz_j3 jz_n jz_j2","discount":"jz_j5"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/RaceSummary/styles.module.css
// module id = 1301
// module chunks = 27